<template>
  <div class="mainContent">
    <!-- <granary-title /> -->
    <nav-bar />
    <ts-bar />
    <mid-drawer />
    <component :is="leftComponent"></component>1
    <component :is="rightComponent"></component>
  </div>
</template>

<script>
// import granaryTitle from "@/components/granaryTitle";
const navBar = () => import("./navBar");
const rightDrawer = () => import("../drawer/rightBar");
const leftDrawer = () => import("../drawer/leftBar");
const midDrawer = () => import("../drawer/choose");

const ghmjDrawer = () => import("../../page/mapDrawer/ghmj");
const yqztzDrawer = () => import("../../page/mapDrawer/yqztz"); //项目信息？
const ssztDrawer = () => import("../../page/mapDrawer/sszt");
const lndnDrawer = () => import("../../page/lndnDrawer/index");
const yzjdDrawer = () => import("../../page/mapDrawer/yzjd");
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["drawerComponent", "leftComponent", "rightComponent"])
  },
  data() {
    return {
      name: "全屏",
      fullScreen: false
    };
  },
  components: {
    // granaryTitle,
    navBar,
    rightDrawer,
    leftDrawer,
    midDrawer,
    ghmjDrawer,
    yqztzDrawer,
    ssztDrawer,
    lndnDrawer,
    yzjdDrawer
  },
  mounted() {
    this.$store.dispatch("drawer/setLeftComponent", "leftDrawer");
    this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
  },
  methods: {
    handleClick() {
      window.open("https://i.svrvr.com/v2/pano/#/pano/56dbf1c31d");
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.mainContent
  height 100%
  position relative
  overflow hidden

  .right-btn-wrap
    position absolute
    right 1%
    top 0.335rem
    cursor pointer
    z-index 7

    span
      color #b4c0db
      background url('~images/index/home/btn-bg.png') no-repeat
      background-size 100% 100%
      width 115px
      height 32px
      line-height 32px
      display inline-block
      text-align center
      font-size 14px
</style>
